var DS3_SendToTray = new Object();

DS3_SendToTray.version = "1.0.0";

var isSending = false;
DS3_SendToTray.send = function (data) {
	if (!isSending) {
		if (helpers.shouldDebug("ds3"))
			console.log("[DS3.SendToTray] send data:", data);
		isSending = true;

		if (!data || typeof data !== "object") {
			console.warn("[DS3.SendToTray] invalid data passed to send:", data);
			return;
		}

		// The country code determines which tray endpoint the data
		// is submitted to.
		const trayEndpoint = {
			AU: "https://35230b4d-5fbf-4eff-a7a8-cb6c9decc067.trayapp.io",
			NZ: "https://99c432bb-914a-4b31-8be8-20883263d3d7.trayapp.io",
		};

		const countryCode = thryvData.thryv_country_alpha2_code;
		const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const payload = {
			fullname: data.submissionValues.full_name,
			firstname: data.submissionValues.full_name.split(" ")[0],
			lastname: data.submissionValues.full_name.split(" ")[1],
			company: data.submissionValues.company,
			email: data.submissionValues.email,
			phone: data.submissionValues.phone_input_only,
			irclickid: null,
			submission_url: window.location.href,
			submissionURL: window.location.href,
			conversion_url: document.referrer,
			utm_campaign: data.submissionValues.utm_campaign,
			utm_content: data.submissionValues.utm_content,
			utm_medium: data.submissionValues.utm_medium,
			utm_source: data.submissionValues.utm_source,
			utm_term: data.submissionValues.utm_term,
			bdr_step: "bdr1",
			thryv_tz: userTimezone,
			g_param: "null",
			country: countryCode,
			demo_variant: "[]",
			gclid: "",
			endpoint: countryCode,
			product_interest: "General Thryv",
			workflowURL: trayEndpoint[countryCode],
		};

		$.ajax({
			type: "POST",
			url: thryvData.ajax_url + "?action=post_to_tray",
			data: payload,
			success: function (response) {
				if (response.data.response.code == 200) {
					if (helpers.shouldDebug("ds3"))
						console.log("[DS3.SendToTray] Response:", response.data.body);
				} else {
					console.error(
						"[DS3.SendToTray] Status:",
						response.data.response.code,
					);
					console.error(
						"[DS3.SendToTray] Error:",
						response.data.response.message,
					);
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error("[DS3.SendToTray] Status:", textStatus);
				console.error("[DS3.SendToTray] Error:", errorThrown);
				console.error("[DS3.SendToTray] Response Body:", jqXHR.responseText);
			},
		});
	}
};

export default DS3_SendToTray;
